import { Icon, symbolName } from './Icon'

type EditIconProps = Readonly<{
  size?: number
  color?: string
}>

export function EditIcon({ size = 20, color = '#1C1B1F' }: EditIconProps) {
  return (
    <Icon
      name={symbolName('square.and.pencil', 'edit')}
      size={size}
      color={color}
    />
  )
}
